// Permissionهای پلتفرم در Console (AP-PLT-02؛ C-AGENT-200): توکن Keycloak فقط Realm Roleها را دارد، پس Permission
// پلتفرم با همان نگاشت سرور (IPlatformRoleMap از rbac-matrix.csv، ستون‌های Platform*) به نقش برگردانده می‌شود.
// تست access.test.ts برابری این جدول با docs/07-security-compliance/rbac-matrix.csv را می‌سنجد. تصمیم نهایی همیشه سرور است.
import { usePlatformSession } from '@phoenix/auth';
import { useMemo } from 'react';

export const PLATFORM_ROLES = {
  admin: 'platform-admin',
  support: 'platform-support',
  billing: 'platform-billing',
  dataSteward: 'platform-data-steward',
  contentEditor: 'platform-content-editor',
} as const;

const { admin, support, billing, dataSteward, contentEditor } = PLATFORM_ROLES;

/** Permission پلتفرم ← Realm Roleهای دارنده (rbac-matrix.csv، is_platform = true). */
export const PLATFORM_PERMISSION_ROLES: Readonly<Record<string, readonly string[]>> = {
  'platform.tenant.view': [admin, support, billing],
  'platform.tenant.create': [admin, billing],
  'platform.tenant.suspend': [admin],
  'platform.plan.manage': [admin, billing],
  'platform.entitlement.override': [admin, billing],
  'platform.license.issue': [admin, billing],
  'platform.support_access.request': [admin, support],
  'platform.announcement.manage': [admin, support],
  'platform.reference_data.manage': [admin, dataSteward],
  'platform.audit.view': [admin],
  'platform.dead_letter.view': [admin, support],
  'platform.dead_letter.resend': [admin],
  'platform.jobs.view': [admin],
  'platform.cfg.pack.author': [admin, contentEditor],
  'platform.cfg.pack.publish': [admin],
  'platform.int.adapter.manage': [admin],
  // AP-INT-10 (US-INT-115): کاتالوگ نگاشت خطای بیمه‌گر.
  'platform.int.error_map.manage': [admin],
  // AP-PLT-05 (C-AGENT-414، C-AGENT-425).
  'platform.sms_credit.manage': [admin, billing],
  'platform.support_ticket.handle': [admin, support],
  // AP-PLT-07 (C-AGENT-1170).
  'platform.subscription.manage': [admin, billing],
};

/** نقش‌های دارنده یک Permission پلتفرم؛ کد ناشناخته ← هیچ (Fail-closed، مانند سرور). */
export function rolesFor(permission: string): readonly string[] {
  return PLATFORM_PERMISSION_ROLES[permission] ?? [];
}

export interface PlatformAccess {
  can: (permission: string) => boolean;
}

/** دسترسی کاربر جاری Console به Permission پلتفرم. */
export function usePlatformAccess(): PlatformAccess {
  const { hasPlatformRole } = usePlatformSession();
  return useMemo(
    () => ({ can: (permission: string) => hasPlatformRole(rolesFor(permission)) }),
    [hasPlatformRole],
  );
}
